import React, { useState } from 'react';
import { useGetCompanyStatistics } from '../../../../traits/api/controls/useGetCompanyStatistics';
import { useControl } from '../../components/ControlLayout';
import { Loading } from '../../../../components/Loading';
import { Error } from '../../../../components/Error';
import { DeviationsTable } from './components/DeviationsTable';
import { SearchInput } from '../../../../components/SearchInput';

import { S } from './PersonnelDeviations.styles';
import { SortDeviations } from './components/DeviationsTable/hooks/useDeviationsTableData';
import { DeviationsSortDropdown } from './components/DeviationsTableSort/DeviationsTableSortDropdown';

export const PersonnelDeviations: React.FC = () => {
  const [page, setPage] = useState(0);
  const control = useControl();
  const [sort, setSort] = useState<SortDeviations>('none');
  const [search, setSearch] = useState('');
  const statistics = useGetCompanyStatistics(
    control.data?.inspectionId,
    control.data?.controlId,
    page,
    sort,
    search
  );

  React.useEffect(() => {
    const onScroll = () => {
      localStorage.setItem('Dev', window.scrollY + '');
    };

    let scroll = Number(localStorage.getItem('Dev'));
    if (!scroll) {
      scroll = 0;
    }
    new Promise((r) => setTimeout(r, 200)).then(() => {
      window.scrollTo({
        top: scroll,
        left: 0,
      });
    });

    window.removeEventListener('s croll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <S.PersonnelDeviationsContainer>
      <S.TableContainer>
        {statistics.isLoading && <Loading />}

        {statistics.isError && <Error refetch={statistics.refetch} />}

        {statistics.isSuccess && (
          <React.Fragment>
            <S.Margin $spacing="xs" />

            <S.Header>
              <S.B3 $color="darkGray">{statistics.count} st</S.B3>

              <S.HeaderActions>
                <SearchInput
                  input={search}
                  setInput={(value) => {
                    setPage(0);
                    setSearch(value);
                  }}
                  placeholder="Sök efter namn"
                />
                <DeviationsSortDropdown
                  sort={sort}
                  setSort={(e) => {
                    setPage(0);
                    setSort(e);
                  }}
                />
              </S.HeaderActions>
            </S.Header>

            <DeviationsTable
              data={statistics.data}
              page={page}
              setPage={setPage}
              numberOfPages={Math.ceil(statistics.count / 20)}
            />
          </React.Fragment>
        )}
      </S.TableContainer>

      <S.Footer />
    </S.PersonnelDeviationsContainer>
  );
};
